import BaseResponse from "@/model/responses/BaseResponse";

class BookingResponse extends BaseResponse {
  static read = {};

  static readBy = {
    data: {
      bookingId: null,
      bookingProfessionalId: null,
      bookingCustomerId: null,
      bookingTopic: null,
      bookingSlots: null,
      bookingMeetingLink: null,
      bookingProfessionalRating: null,
      bookingProfessionalReview: null,
      bookingCustomerRating: null,
      bookingCustomerReview: null,
      bookingAmount: null,
      bookingStartTime: null,
      bookingMessage: null,
      bookingEndTime: null,
      bookingPaymentStatus: null,
      bookingCreatedAt: null,
      bookingUpdatedAt: null,
      bookingStatus: null
    }
  };

  static readByCustomerId = {
    data: [
      {
        bookingId: null,
        bookingProfessionalId: null,
        bookingCustomerId: null,
        bookingTopic: null,
        bookingSlots: null,
        bookingMeetingLink: null,
        bookingProfessionalRating: null,
        bookingProfessionalReview: null,
        bookingCustomerRating: null,
        bookingCustomerReview: null,
        bookingAmount: null,
        bookingStartTime: null,
        bookingMessage: null,
        bookingEndTime: null,
        bookingPaymentStatus: null,
        bookingCreatedAt: null,
        bookingUpdatedAt: null,
        bookingStatus: null
      }
    ]
  };
}

export default BookingResponse;
